import {createUseStyles} from 'react-jss';
export default createUseStyles({
    root:{
        display:'inline-flex',
        height: '100%',
        flexDirection:"row",
        gap: 5,
        overflowX: 'auto',
    }
});
